import { useEffect } from 'react';
import { useOverflow } from './OverflowContext';

export const FixedDocument = ({ children }: React.PropsWithChildren) => {
  const { requestOverflowHidden, unsetOverflowHidden } = useOverflow();

  useEffect(() => {
    requestOverflowHidden();
    return unsetOverflowHidden;
  }, []);

  return children;
};
